import "./ReadMessage.css";
import { readMessage } from "../../../../../Services/Inbox.js";
import { useEffect, useState } from "react";
import DialogModal from "../../../../Modals/dialogModal";


const ReadMessage = (props) => {

    const [showModal, setShowModal] = useState(false)

    const handleRead = async (id) => {

        let rsp = await readMessage(id);

        if(rsp?.Error === false){

        }else{
            setShowModal(true)
        }
    }

    const handleResponseMessage = () => {

        props.setSelectedType({
            type: 0,
            id: props.messege.id_from,
            preMessage: '<br /><br /><p>En respuesta a:</p><p>----------------------------------------------</p>' + props.messege.body
        })

    }

    useEffect(() => {
            handleRead(props.messege.id);
    }, []);

    return(
        <div className="buzon-read-messege-div">
            <DialogModal  showModal={showModal} setShowModal={setShowModal}>
                <h3>El mensaje no pudo ser marcado como leido</h3>
            </DialogModal>
            <div className="buzon-read-messege-head">
                {
                    props.selected === 0 ?
                    <>
                        <div>
                            <h3>De</h3>
                            <h4>{props.messege.name}</h4>
                        </div>
                        <div>
                            <h3>Para</h3>
                            <h4>{props.usrData.name}</h4>
                        </div>
                    </>
                    :
                    <>
                        <div>
                            <h3>De</h3>
                            <h4>{props.usrData.name}</h4>
                        </div>
                        <div>
                            <h3>Para</h3>
                            <h4>{props.messege.name}</h4>
                        </div>
                    </>
                }
            </div>
            <div className="buzon-read-messege-input-div">
                <label htmlFor="">Asunto: </label>
                <h3>{props.messege.subject}</h3>
            </div>
            <div className="buzon-read-messege-input-body">
                <br /><br />
                <p dangerouslySetInnerHTML={{__html: props.messege.body}} style={{fontSize:22}}></p>
            </div>
            {
                props.selected === 0 ?
                <div className="buzon-read-messege-controls-div">
                    <button className="green-btn" onClick={handleResponseMessage}>Responder</button>
                </div>
                :
                <></>
            }
        </div>
    );
}

export default ReadMessage;